// extracted by mini-css-extract-plugin
export var dropdownButton = "_1s-0";
export var fullWidthDropdownButton = "_1s-1";
export var icon = "_1s-3";
export var iconPlaceholder = "_1s-2";
export var menuItemRow = "_1s-8";
export var separator = "_1s-d";
export var shortcutContainer = "_1s-7";
export var shortcutIconLg = "_1s-6";
export var shortcutIconMd = "_1s-5";
export var shortcutIconSm = "_1s-4";
export var submenuChevron = "_1s-c";
export var submenuDropdown = "_1s-9";
export var submenuTriggerRow = "_1s-a";
export var submenuTriggerRowOpen = "_1s-b";